<template>
  <div class="container formula-masura-aptamil">
    <div class="row legend">
      <div class="col-lg-10 offset-lg-1">
        <div class="mx-auto d-inline-block">
          <div>
            <p class="text-left"><span class="dot light"> </span>O MĂSURĂ NOUL Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></p>
          </div>
          <div>
            <p class="text-left"><span class="dot dark"> </span>O MĂSURĂ APTAMIL (FORMULĂ ANTERIOARĂ)</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row grafic-formula pt-3">
      <div class="col-lg-10 offset-lg-1">
        <div class="row">
          <div class="col-lg-4 pt-1">
            <div class="border-light">
              <span class="label-day">ZIUA<br/>1-3 </span>
              <p>
                <span class="dot light"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
            </div>
          </div>
          <div class="col-lg-4 pt-1">
            <div class="border-light">
              <span class="label-day"> ZIUA<br/>4-6</span>
              <p><span class="dot light"></span> <span class="dot light"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
            </div>
          </div>
          <div class="col-lg-4 pt-1">
            <div class="border-light">
              <span class="label-day"> ZIUA<br/>7-9</span>
              <p><span class="dot light"></span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
            </div>
          </div>
        </div>

        <div class="row pt-lg-2">
          <div class="col-lg-4 pt-1">
            <div class="border-light">
              <span class="label-day">ZIUA<br/>10-12 </span>
              <p><span class="dot light"></span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot dark"> </span> <span class="dot dark"> </span></p>
            </div>
          </div>
          <div class="col-lg-4 pt-1">
            <div class="border-light">
              <span class="label-day"> ZIUA<br/>13-15 </span>
              <p><span class="dot light"></span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot dark"> </span></p>
            </div>
          </div>
          <div class="col-lg-4 pt-1">
            <div class="border-light">
              <span class="label-day">ZIUA<br/>16-18</span>
              <p><span class="dot light"></span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span> <span class="dot light"> </span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.formula-masura-aptamil {
  padding: 30px 0;

  .label-day {
    padding-right: 15px;
    color: #001388;
    font-size: 16px;
    line-height: 18px;
  }

  .dot.light {
    background-color: #001388;
  }

  .dot.dark {
    background-color: #abc9e9;
  }

  .border-light p {
    border-color: #001388;
  }

  .border-light .dot {
    margin-bottom: -2px;
  }

  .legend {
    p {
      margin-bottom: 0;
    }
  }
}

</style>
